const componentStyles = (theme) => ({
  header: {
    background:"#f37900"
      
  },
});

export default componentStyles;
